import React, {FC} from 'react';

import {useCustomTable} from 'components/@common/widgets/custom-table/custom-table';
import {useAppSelector} from 'store/config/hooks';

import {selectForecastCommentsTable} from '../../model/slice';
import {TForecastCommentsCore} from '../../model/types';
import {useForecastCommentsColumns} from './hooks/use-foracast-comments-columnts';

export const ForecastCommentsTable: FC = () => {
    const tableData = useAppSelector(selectForecastCommentsTable);

    const columns = useForecastCommentsColumns(tableData);

    const {customTableJSX} = useCustomTable<TForecastCommentsCore>({
        rowKey: 'id',
        className: 'ais-documents-register-table mt-5',
        locale: {emptyText: 'Нет данных'},
        dataSource: tableData,
        bordered: true,
        columns,
    });

    return <>{customTableJSX}</>;
};

ForecastCommentsTable.displayName = 'ForecastCommentsTable';
